import { noop } from 'lodash';

import createReducer from '../utils/createReducer';
import switchFunc from '../utils/switchFunc';
import decodeChatChannel from '../normalizers/decodeChatChannel';
import { API_CALL_SUCCESS, RESET_CHALLENGE, SET_CHAT_CHANNEL } from '../constants/actionTypes';
import { CHALLENGE, SPORTS_LIST } from '../constants/apiTypes';

const initialState = {
  channelId: undefined,
  channels: []
};

const apiSuccessReducer = switchFunc(
  {
    [CHALLENGE]: (state, { force }) =>
      force
        ? {
            channelId: 'challenge'
          }
        : {},
    [SPORTS_LIST]: (state, action) => ({
      channels: action.data.map(decodeChatChannel)
    })
  },
  () => noop
);

export default createReducer(initialState, {
  [API_CALL_SUCCESS]: (state, action) => apiSuccessReducer(action.api)(state, action),
  [SET_CHAT_CHANNEL]: (state, action) => ({
    channelId: action.channelId
  }),
  [RESET_CHALLENGE]: state => ({
    channel: state.channelId === 'challenge' ? undefined : state.channelId
  })
});
